const forgotPassword = {
  toastr: 'Link sent by email',
  toastr1: 'Email successfully sent'
};

export default forgotPassword;
